import styled, { css } from 'styled-components';
import { mediaMixin, spaceMixin, Spacer, ToggleButton } from '@zillow/constellation';

export const StyledSchedulerButton = styled(ToggleButton)`
  font-size: 10px;
  min-width: 95px;

  /* 481 */
  ${mediaMixin(
    'md',
    css`
      font-size: 14px;
      min-width: 118px;
    `,
  )}

  ${(props) =>
    props.theme &&
    props.theme.ns &&
    css`
        && {
            /* removes user agent style (chrome) that puts a yellow outline around button on focus */
            outline-width: 0;
    `}
`;

export const StyledInlineSpacer = styled(Spacer)`
  display: inline-block;
  margin: ${spaceMixin('xs')} ${spaceMixin('xs')} ${spaceMixin('xs')} 0;
`;
